import { FormEvent, useCallback } from "react";

export const contactInfo = {
  phone: "71625260",
  email: "qimah.contact@gmail.com",
};

export const socialLinks = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/qimah_tech",
    icon: "instagram",
  },
  {
    label: "TikTok",
    href: "https://www.tiktok.com/@qimah_tech",
    icon: "tiktok",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/1BdosTZiHg/",
    icon: "facebook",
  },
];

export const useContactController = () => {
  const handleSubmit = useCallback((event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
  }, []);

  return { contactInfo, socialLinks, handleSubmit };
};
